import { useContext } from 'react';
import Button from '../Button/Button';
import {
  Container,
  Title,
  InputsContainer,
  ButtonWrapper,
  Input,
  Textarea,
} from '../PostAJobFormComponent/PostAJobFormComponent.styles';
import { PostAJobContext } from '@/utils/context';
import { JOB } from '@/utils/constants';

const PostAJobFormCompanyDetails = (props: any) => {
  const { formState, setFormState, errorsState, setErrorsState } =
    props.postAJobProps;
  const { setCurrentStep, setIsCompanyReady } = useContext(PostAJobContext);
  const changeHandler = (e: any) => {
    setFormState((prevState: any) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };
  const fileChangeHandler = (e: any) => {
    setFormState((prevState: any) => {
      return {
        ...prevState,
        companyLogoFilename: e.target.files[0].name,
        companyLogoFile: e.target.files[0],
      };
    });
  };
  const companyButtonClickHandler = () => {
    if (formState.company.trim()) {
      setCurrentStep(JOB);
      setIsCompanyReady(true);
    } else {
      setIsCompanyReady(false);
      setErrorsState((prevState: any) => {
        return {
          ...prevState,
          company: true,
        };
      });
    }
  };
  return (
    <Container>
      <Title>Company Details</Title>
      <InputsContainer>
        <label>
          Company Name <span>(required)</span>
        </label>
        <Input
          type="text"
          name="company"
          value={formState.company}
          onChange={changeHandler}
          placeholder="Company Name"
          isEmpty={errorsState.company && !formState.company.trim()}
        />
        <label>
          Company Logo <span>(optional)</span>
        </label>
        <input
          name="file"
          onChange={fileChangeHandler}
          type="file"
          accept="image/jpeg, image/png, image/jpg"
        />
        <label>
          Company Website <span>(optional)</span>
        </label>
        <Input
          type="text"
          name="companyUrl"
          value={formState.companyUrl}
          onChange={changeHandler}
          placeholder="http://"
        />
        <label>
          Company Description <span>(optional)</span>
        </label>
        <Textarea
          name="companyDescription"
          value={formState.companyDescription}
          onChange={changeHandler}
          placeholder="Add description here"
        />
      </InputsContainer>
      <ButtonWrapper>
        <Button clickHandler={companyButtonClickHandler}>
          Go to Job Details
        </Button>
      </ButtonWrapper>
    </Container>
  );
};

export default PostAJobFormCompanyDetails;
